import { logClientError } from "../helpers/clientLogger";

export const formatDate = (
  date: string | number | Date | null | undefined
): string => {
  if (!date) return "-";
  return (
    new Date(date).toLocaleDateString() +
    " " +
    new Date(date).toLocaleTimeString()
  );
};

export const formatTenantName = (
  displayName: string | null | undefined
): string => {
  try {
    return displayName
      ? displayName.replaceAll("-", " ").toUpperCase()
      : "UpLife";
  } catch (e) {
    console.log(e);
    logClientError(e, { surface: "tenant-name-format", severity: "warn" });
    return "UpLife";
  }
};

export const parseVersionToNumber = (
  version: string | null | undefined
): number | null => {
  if (!version) return null;
  const versionParts = version.split(".").map(Number);
  while (versionParts.length < 3) versionParts.push(0);
  return (versionParts[0] * 1000 + versionParts[1]) * 1000 + versionParts[2];
};

export const isSameDay = (d1: Date, d2: Date): boolean => {
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
};

interface TimestampEntry {
  seconds: number;
}

interface RitualHistoryEntry {
  t?: TimestampEntry;
  th?: Record<string, TimestampEntry>;
}

export const getTimestampSeconds = (
  entry: RitualHistoryEntry | null | undefined
): number | null => {
  const direct = entry?.t?.seconds;
  if (typeof direct === "number") return direct;
  const thValues = Object.values(entry?.th || {});
  if (!thValues.length) return null;
  const latest = thValues.reduce<TimestampEntry | null>((acc, cur) => {
    if (typeof cur?.seconds !== "number") return acc;
    if (!acc) return cur;
    return cur.seconds > (acc?.seconds || 0) ? cur : acc;
  }, null);
  return typeof latest?.seconds === "number" ? latest.seconds : null;
};

export const getBrandingFromJourneyForItem = (
  itemId: string | null | undefined,
  allJourneys: Record<string, unknown> | null | undefined
): unknown => {
  if (!itemId || !allJourneys) return null;
  const journeyId = Object.keys(allJourneys).find(
    (jid) =>
      itemId.startsWith(`${jid}_`) ||
      itemId.includes(`${jid}_s`) ||
      itemId.includes(`${jid}-s`) ||
      itemId === jid
  );
  return journeyId ? allJourneys[journeyId] : null;
};

export const getSessionTitleFromJourney = (
  itemId: string | null | undefined,
  allJourneys: Record<string, any> | null | undefined
): string | null => {
  if (!itemId || !allJourneys) return null;
  const parts = itemId.split("_s");
  if (parts.length < 2) return null;
  const journeyId = parts[0];
  const sessionNumber = (parts[1] || "").split("_")[0];
  if (!journeyId || !sessionNumber) return null;
  const sessionKey = `${journeyId}_s${sessionNumber}`;
  return allJourneys?.[journeyId]?.sessions?.[sessionKey]?.title || null;
};

export const getJourneyDays = (
  journeySessions: Record<string, { order?: number }> | null | undefined
): number => {
  return Object.values(journeySessions || {}).reduce(
    (acc, cur) => (cur?.order !== 0 ? acc + 1 : acc),
    0
  );
};
